// Auto-generated flat translation map assembled from per-namespace files.
// Add new keys to the matching <namespace>.json (create one per module).
// Key format: <namespace>.<area>.<slug> — flat dotted strings.
import ai from "./ai.json";
import appstore from "./appstore.json";
import appointments from "./appointments.json";
import calendar from "./calendar.json";
import common from "./common.json";
import company from "./company.json";
import contacts from "./contacts.json";
import crm from "./crm.json";
import crm_proposals from "./crm_proposals.json";
import csat from "./csat.json";
import dashboard from "./dashboard.json";
import email from "./email.json";
import header from "./header.json";
import monitoring from "./monitoring.json";
import huddle from "./huddle.json";
import helpdesk from "./helpdesk.json";
import home from "./home.json";
import inbox from "./inbox.json";
import knowledge from "./knowledge.json";
import lang from "./lang.json";
import login from "./login.json";
import loyalty from "./loyalty.json";
import marketing from "./marketing.json";
import nav from "./nav.json";
import nexus from "./nexus.json";
import page from "./page.json";
import profile from "./profile.json";
import projects from "./projects.json";
import regulatory from "./regulatory.json";
import quick_create from "./quick_create.json";
import sentiment from "./sentiment.json";
import settings from "./settings.json";
import users from "./users.json";
import unauthorized from "./unauthorized.json";
import sidebar from "./sidebar.json";
import social_media from "./social_media.json";
import validation from "./validation.json";
import voice from "./voice.json";

const translations = {
  ...ai,
  ...appstore,
  ...appointments,
  ...calendar,
  ...common,
  ...company,
  ...contacts,
  ...crm,
  ...crm_proposals,
  ...csat,
  ...dashboard,
  ...email,
  ...header,
  ...monitoring,
  ...huddle,
  ...helpdesk,
  ...home,
  ...inbox,
  ...knowledge,
  ...lang,
  ...login,
  ...loyalty,
  ...marketing,
  ...nav,
  ...nexus,
  ...page,
  ...profile,
  ...projects,
  ...regulatory,
  ...quick_create,
  ...sentiment,
  ...settings,
  ...users,
  ...unauthorized,
  ...sidebar,
  ...social_media,
  ...validation,
  ...voice,
};

export default translations;
